// const itemInArrObjsByValue = (value, arr, key = 'id') => arr.filter((item) => item[key] === value)[0]
const itemInArrObjsByValue = (value, arr, key = 'id') => arr.filter((item) => {
	const numberedVal = Number(value)
	const numberedItem = Number(item[key])
	const isValsConvertedToNum = (numberedVal !== null && numberedItem !== null) && (!isNaN(numberedVal) && !isNaN(numberedItem))
	return isValsConvertedToNum ? numberedVal === numberedItem : value === item[key]
})[0]

export default itemInArrObjsByValue
